export default __webpack_public_path__ + "static/media/Big Data Icon.1a9f1e12.svg";